import { get } from 'lodash';
import { getMetaSiteId } from '../base-params/base-params-selectors';
export const FETCH_EXPERIMENTS_REQUEST = 'experiments/FETCH_EXPERIMENTS_REQUEST';
export const FETCH_EXPERIMENTS_SUCCESS = 'experiments/FETCH_EXPERIMENTS_SUCCESS';
export const fetchExperimentsRequest = () => ({
    type: FETCH_EXPERIMENTS_REQUEST,
});
export const fetchExperimentsSuccess = (payload) => ({
    type: FETCH_EXPERIMENTS_SUCCESS,
    payload,
});
export function fetchExperiments({ metaSiteId } = {}) {
    return async (dispatch, getState, { httpClient }) => {
        const msId = metaSiteId || getMetaSiteId(getState());
        dispatch(fetchExperimentsRequest());
        try {
            const body = await httpClient.get(`/_api/wix-laboratory-server/v1/laboratory/platform/conductAllInScopes?scopes=wix-comments-web&scopes=ricos&requestContext.overrideCriteria.entityId=${msId}`);
            return dispatch(fetchExperimentsSuccess(get(body.data, 'values', {})));
        }
        catch {
            return dispatch(fetchExperimentsSuccess({}));
        }
    };
}
//# sourceMappingURL=experiments-actions.js.map